/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Database_AnswerInputs */

const en_landing_faq_database_answer = /** @type {(inputs: Landing_Faq_Database_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drizzle ORM handles PostgreSQL, MySQL, SQLite, Turso, and Cloudflare D1. Switch providers by editing DATABASE_PROVIDER in your .env — the schema templates and drizzle config adapt automatically.`)
};

const zh_landing_faq_database_answer = /** @type {(inputs: Landing_Faq_Database_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drizzle ORM 支持 PostgreSQL、MySQL、SQLite、Turso 和 Cloudflare D1。只需修改 .env 中的 DATABASE_PROVIDER——schema 模板和 drizzle 配置会自动适配。`)
};

/**
* | output |
* | --- |
* | "Drizzle ORM handles PostgreSQL, MySQL, SQLite, Turso, and Cloudflare D1. Switch providers by editing DATABASE_PROVIDER in your .env — the schema templates an..." |
*
* @param {Landing_Faq_Database_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_database_answer = /** @type {((inputs?: Landing_Faq_Database_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Database_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_database_answer(inputs)
	return zh_landing_faq_database_answer(inputs)
});
export { landing_faq_database_answer as "landing.faq.database.answer" }